import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
// import SmartlookClient from 'smartlook-client';
import {
  ENVIRONMENT,
  // SMARTLOOK_PROJECT_KEY,
  VITE_SENTRY_DSN,
} from './config/index.ts';
import * as Sentry from '@sentry/react';
import { ApolloProvider } from '@apollo/client';
import client from './lib/apolloClient';

// SmartlookClient.init(SMARTLOOK_PROJECT_KEY);

Sentry.init({
  dsn: VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  environment: ENVIRONMENT,
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
  // </React.StrictMode>
);
